import axios from "axios";

const formDataAxios = axios.create({
   headers: {
        'Content-Type': 'multipart/form-data',
        
    },
    withCredentials: true
});

export default formDataAxios;

